/* @flow */
import * as React from 'react';

const StarEmptyLarge = props => (
  <svg width={40} height={38} viewBox="0 0 40 38" fillRule="evenodd" {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#A0A3B1"
      points="26.18 12.342 40 14.334 30 23.935 32.36 37.5 20 31.092 7.64 37.5 10 23.935 0 14.334 13.82 12.342 20 0"
      fillOpacity={0}
    />
    <path
      stroke="#505FB4"
      strokeWidth={2}
      fill="none"
      d="M20,2.234 L14.48,13.257 L2.17,15.031 L11.076,23.583 L8.971,35.684 L20,29.966 L31.029,35.684 L28.924,23.583 L37.83,15.031 L25.52,13.257 L20,2.234 Z"
    />
  </svg>
);

export default StarEmptyLarge;



// WEBPACK FOOTER //
// ./src/assets/images/icons/star-empty-large.js